import contact from "./contact.json";

// The public form ID can be overridden for another deployment.
export const TALLY_FORM_ID = (process.env.REACT_APP_TALLY_FORM_ID ?? "D4rX55").trim();
export const CONTACT_URL = TALLY_FORM_ID ? `https://tally.so/r/${TALLY_FORM_ID}` : "";

export const WHATSAPP_MESSAGE = "Hello Sheetal, I visited Panchmaya.com and would like to inquire about 1:1 Coaching sessions";
export const WHATSAPP_URL = `https://wa.me/${contact.phone}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const NAV_LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/#coaching", label: "1:1 Coaching", id: "coaching" },
  { to: "/journey", label: "The Journey", id: "journey" },
  { to: "/about", label: "About", id: "about" },
];

export const STEPS = [
  {
    key: "perceive",
    word: "Perceive",
    through: "through the five senses",
    text: "Notice how you take in the world: what you see, hear, touch, taste and smell, and how it shapes the way you feel.",
  },
  {
    key: "release",
    word: "Release",
    through: "through the five organs of action",
    text: "Make room to let go. Through movement, voice, breath and simple, conscious action, you set down some of what you carry.",
  },
  {
    key: "reconnect",
    word: "Reconnect",
    through: "through the five elements",
    text: "Cultivate harmony across physical energy, focus, and clarity, and return to a steadier sense of yourself and your purpose.",
  },
];

export const STAGES = [
  {
    n: "01", name: "Body", kosha: "Annamaya", meaning: "the layer of food and form",
    element: "Earth", days: "Days 1–4", color: "#B4533A",
    short: "Become aware of physical sensations, posture and everyday movement habits.",
    long: "We begin with what is most tangible. Annamaya is the physical layer: the body that eats, rests, moves and senses. Here you slow down enough to notice tension, comfort and habit, and use the five senses as an anchor to the present moment.",
    explore: ["Noticing where you hold tension", "Grounding through the senses", "Gentle attention to rest and movement"],
  },
  {
    n: "02", name: "Breath", kosha: "Pranamaya", meaning: "the layer of breath and energy",
    element: "Water", days: "Days 5–8", color: "#3D6A9C",
    short: "Notice the breath, and how energy rises and falls.",
    long: "Pranamaya is the layer of breath and vitality, the movement that keeps us alive. In this stage you get to know your own breathing patterns and notice how your energy shifts across the day, in work and in relationships.",
    explore: ["Observing natural breathing rhythms", "Simple breath practices", "Tracking what gives and drains energy"],
  },
  {
    n: "03", name: "Mind", kosha: "Manomaya", meaning: "the layer of thoughts and feelings",
    element: "Fire", days: "Days 9–12", color: "#4F8452",
    short: "Watch thoughts and feelings without being carried away.",
    long: "Manomaya is the layer of everyday thinking and emotion: reactions, stories and habits of mind. Here you begin to recognise familiar patterns, and to meet them with curiosity and kindness rather than judgement.",
    explore: ["Recognising repeating thought patterns", "Reflective journaling prompts", "Practising self-compassion"],
  },
  {
    n: "04", name: "Awareness", kosha: "Vijnanamaya", meaning: "the layer of insight and discernment",
    element: "Air", days: "Days 13–16", color: "#B98420",
    short: "Step back into the quiet observer that sees clearly.",
    long: "Vijnanamaya is the layer of deeper knowing: the part of you that can witness thoughts instead of being lost in them. This stage invites clarity, the ability to tell intuition from worry, and a closer look at what matters to you.",
    explore: ["The practice of witnessing", "Listening for intuition", "Reflecting on values and direction"],
  },
  {
    n: "05", name: "Connection", kosha: "Anandamaya", meaning: "the layer of contentment and wholeness",
    element: "Space", days: "Days 17–20", color: "#71539F",
    short: "Rest in a quieter sense of contentment and wholeness.",
    long: "Anandamaya, often translated as the layer of bliss, points to the ease that remains when struggle softens. In this final stage you explore stillness, open awareness and contentment that does not depend on circumstances.",
    explore: ["Stillness and open-awareness practice", "Noticing everyday contentment", "Carrying presence into daily life"],
  },
];

export const MARQUEE = [
  "From darkness to light", "Perceive", "Release", "Reconnect",
  "Body", "Breath", "Mind", "Awareness", "Connection",
];
